// URL configuration for different environments
// Admin panel is now a SEPARATE PROJECT deployed on its own subdomain

const isDev = process.env.NODE_ENV === 'development';

// Main site URL
export const SITE_URL = isDev 
  ? 'http://localhost:3000' 
  : 'https://renpowerltd.com';

// Admin panel URL (separate project on subdomain)
// In dev: runs on port 3001, in prod: admin.renpowerltd.com
export const ADMIN_URL = isDev 
  ? 'http://localhost:3001' 
  : 'https://admin.renpowerltd.com';

// API URL
export const API_URL = isDev 
  ? 'http://localhost:5000/api' 
  : 'https://api.renpowerltd.com/api';

// Helper to get full admin route URL (for external links from main site)
export const getAdminUrl = (path: string = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${ADMIN_URL}${cleanPath}`;
};

// Helper to check if we're on admin subdomain
export const isAdminSubdomain = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'admin.renpowerltd.com';
};

// Main site URL for redirects from admin panel
export const getMainSiteUrl = (path: string = '') => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return isDev ? `http://localhost:3000${cleanPath}` : `https://renpowerltd.com${cleanPath}`;
};
